import { render } from "./Articles.vue?vue&type=template&id=60d6357c"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=60d6357c&lang=scss"
import "./Articles.vue?vue&type=style&index=1&id=60d6357c&lang=css"

import exportComponent from "/Users/ruisilva/Desktop/Projects/qmulher/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__